import { mapGetters } from "vuex";

const navBarMixins = {
  computed:{
    ...mapGetters([
      "customerId",
      "email",
      "name",
    ])
  }
}

export default navBarMixins;